var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile",on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.getInitials(_vm.$auth?.user?.name))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }